import React, { useEffect, useState } from 'react';
import { getFormattedDate } from './helpers';

export const DateTimeDisplay = ({ tz, format, interval = 1000 }) => {
    const [dateTime, setDateTime] = useState(getFormattedDate(tz, format));

    useEffect(() => {
        const intervalId = setInterval(() => setDateTime(getFormattedDate(tz, format)), interval);

        return () => clearInterval(intervalId);
    }, [tz, format, interval, dateTime]);

    return (
        <>
            {dateTime}
        </>
    );
};

export default DateTimeDisplay;
